import React from 'react';
import { BulkPrintHistoryCreateTemplate } from 'themes/modules/order/pages';
import { BulkPrintHistoryViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new BulkPrintHistoryViewStore(rootStore), 'bulkPrintHistoryViewStore')
class BulkPrintHistoryCreate extends React.Component {
	render() {
		return <BulkPrintHistoryCreateTemplate {...this.props} />;
	}
}

export default BulkPrintHistoryCreate;



// WEBPACK FOOTER //
// ./src/modules/order/pages/BulkPrintHistoryCreate.jsx